module.exports = __webpack_public_path__ + "static/media/samsung-aife-2020-storage.9ee0928c.mp4";